import React, { Component } from 'react';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';
import { ACTIONS } from '../../actions/actionTypes';
import {newMessage} from '../InteractionViews/interactions';
import Spinner from '../components/spinner';
import * as game from '../../controllers';

class NotificationsView extends Component {
    constructor (props) {
        super(props);
        this.state = {
            loading: true,
            notifications: null
        };
    }

    componentDidMount () {
        this.setState({loading: true});
        game.notifications.getNotification().then(response => {
            this.setState({loading: false});
            // Set notfication as received
            let status = {'received': new Date()};
            response.map(item => {
                if (!item.received) {
                    game.notifications.updateNotification(item._id, status).catch(e => {
                        console.warn('Error setting notification as received', e);
                    });
                }
            });

            this.setState({
                notifications: response
            });
        }).catch(error => {
            this.setState({loading: false});
            console.warn('=== Error (notificationView) ===', error);
        });
    }

    renderNotifications () {
        if (!this.state.notifications) {
            return (
                <div className='noNotifications'>
                    <h2>Sem novas notificações no momento</h2>
                </div>
            );
        }

        if (!this.state.notifications.length) {
            return (
                <div className='noNotifications'>
                    <h2>Sem novas notificações no momento</h2>
                </div>
            );
        } else {
            return this.state.notifications.map((item, index) => {
                let unread = (!item.seen) ? ' unread' : '';
                return (
                    <div
                        key={index}
                        onClick={(e) => {
                            this.props.openNotification({notification: item, title: item.title, content: item.content, type: item.interactionType, from: 'UFJF'});
                        }}
                        className={'list-item' + unread}
                    >
                        <div className='title ellipsis'>{item.title}</div>
                        <div className='text ellipsis'>{item.body}</div>
                    </div>
                );
            });
        }
    }

    render () {
        return (
            <div className='browser notification interaction flex'>
                <div className='fixed'>
                    <div className='window-buttons'>
                        <div onClick={() => this.props.push('/')} className='btn-circle' />
                        <div onClick={() => this.props.push('/')} className='btn-circle' />
                        <div onClick={() => this.props.push('/')} className='btn-circle' />
                    </div>
                    <header>
                        <span className='rounded-input'>Notificações</span>
                    </header>
                </div>

                {(this.state.loading && !this.state.notifications)
                    ? <Spinner />
                    : <div className='list-wrapper'>
                        <div>
                            {this.renderNotifications()}
                        </div>
                    </div>
                }
            </div>
        );
    };
};

const mapStateToProps = ({user}) => {
    const userItem = user.user;
    return {userItem};
};

const mapDispatchToProps = (dispatch) => ({
    openNotification: (item) => dispatch({
        type: ACTIONS.NOTIFICATION_OPEN,
        payload: item
    }),
    push: (location) => dispatch(push(location))
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsView);



// WEBPACK FOOTER //
// ./src/views/NotificationsViews/notificationsView.js